import { Loader2 } from 'lucide-react'
import { lazy, Suspense } from 'react'
import { Navigate, createBrowserRouter } from 'react-router-dom'
import AppLayout from '@/layouts/AppLayout'
import { useAuth } from '@/features/auth/AuthContext'
import LoginPage from '@/features/auth/LoginPage'
import HomePage from '@/features/assets/HomePage'

// The scanner pulls in the ZXing WASM fallback, so it loads only when opened.
const ScannerPage = lazy(() => import('@/features/scanner/ScannerPage'))
const RegisterPage = lazy(() => import('@/features/assets/RegisterPage'))
const AssetDetailPage = lazy(() => import('@/features/assets/AssetDetailPage'))
const AssetListPage = lazy(() => import('@/features/assets/AssetListPage'))
const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'))

const Loading = () => (
  <div className="flex min-h-dvh items-center justify-center">
    <Loader2 className="h-6 w-6 animate-spin text-forest" aria-label="Loading" />
  </div>
)

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth()
  if (status === 'loading') return <Loading />
  if (status === 'anonymous') return <Navigate to="/login" replace />
  return <Suspense fallback={<Loading />}>{children}</Suspense>
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <RequireAuth><AppLayout /></RequireAuth>,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'scan', element: <ScannerPage /> },
      { path: 'register', element: <RegisterPage /> },
      { path: 'assets', element: <AssetListPage /> },
      { path: 'assets/:assetId', element: <AssetDetailPage /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
